"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsxs, jsx, Fragment } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import { TbMoodSadFilled, TbMoodSmileFilled } from 'react-icons/tb';
import { Avatar } from '../../../ui-kit/avatar.mjs';
import { Icon } from '../../../ui-kit/icon.mjs';

const IntegrationAvatarStatus = ({ integration, ...props }) => {
  if (!integration.connection) return null;
  const disconnected = integration.connection.disconnected;
  const StatusIcon = disconnected ? TbMoodSadFilled : TbMoodSmileFilled;
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      Icon,
      {
        className: clsx(
          "absolute -top-1.5 -right-1.5 text-white bg-white rounded-full",
          disconnected ? "fill-tomato-11" : "fill-grass-11"
        ),
        children: /* @__PURE__ */ jsx(StatusIcon, { "aria-hidden": "true", ...props })
      }
    ),
    /* @__PURE__ */ jsx("span", { className: "sr-only", children: disconnected ? " - disconnected" : " - connected" })
  ] });
};
const IntegrationAvatar = ({
  integration,
  className,
  ...props
}) => {
  return /* @__PURE__ */ jsxs("div", { className: clsx("relative", className), ...props, children: [
    /* @__PURE__ */ jsx(Avatar, { src: integration.logoUri, name: integration.name, "aria-hidden": "true" }),
    /* @__PURE__ */ jsx(IntegrationAvatarStatus, { integration })
  ] });
};

export { IntegrationAvatar };
